import React, { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Alert,
} from 'reactstrap';
import { toast } from 'react-toastify';
import api from '~/services/api';

/**
 * Modal de confirmação de revogação de PartnerApplication.
 *
 * Diferente do delete (soft-delete): revoke mantém a aplicação registrada
 * pra auditoria mas bloqueia auth imediatamente.
 *
 * Props:
 *   show, setShow
 *   application
 *   onRevoked   callback após sucesso (recebe a aplicação atualizada)
 */
export default function RevokeModal({ show, setShow, application, onRevoked }) {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    setReason('');
    setShow(false);
  };

  const handleRevoke = async () => {
    if (!application?.id) return;
    setLoading(true);
    try {
      const { data } = await api.post(
        `administrator/partner-applications/${application.id}/revoke`,
        { reason: reason || null }
      );
      toast.success('Aplicação revogada com sucesso!');
      setReason('');
      setShow(false);
      if (onRevoked) onRevoked(data?.data);
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error('Não foi possível revogar a aplicação.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Revogar aplicação</ModalHeader>
      <ModalBody>
        <Alert color="warning">
          <strong>{application?.name}</strong> será revogada imediatamente.
          Todas as integrações ativas usando essas credenciais deixarão de
          autenticar.
        </Alert>

        <FormGroup>
          <Label>Motivo (opcional)</Label>
          <textarea
            className="form-control"
            rows={3}
            value={reason}
            maxLength={255}
            onChange={e => setReason(e.target.value)}
            placeholder="Ex: Credenciais vazadas, parceiro encerrou contrato, etc."
          />
          <small className="text-muted">{reason.length}/255 caracteres</small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color="danger"
          className="new-layout-btn main"
          onClick={handleRevoke}
          disabled={loading}
        >
          {loading ? 'Revogando...' : 'Revogar aplicação'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
